import { Select } from 'antd';
import { KANAL_AGACI } from './kanal';

const TUMU = '__tum__';

/**
 * Iki seviyeli kanal secimi: grup satiri secilebilir, alt kanallar girintili. G2b: alt kanali olan HER grubun
 * alt satirlari basilir (eski "tek alt kanalli grupta alt satir yok" kurali Online grubuyla birlikte kalkti).
 * S289/K9: E-Ticaret uc (Trendyol, Yemeksepeti, Getir), Kurumsal tek (Diğer Kurumsal) alt kanalla; secenekler
 * KANAL_AGACI'ndan gelir. `virtual={false}`: liste sanal listeye kirpilmasin.
 */
export function KanalSecici({ value, onChange }: { value: string | null; onChange: (k: string | null) => void }) {
  const secenekler = [
    { value: TUMU, label: 'Tüm kanallar' },
    ...KANAL_AGACI.flatMap((g) => [
      { value: g.grup, label: g.grup },
      ...g.kanallar.map((k) => ({ value: k, label: <span className="pl-3">{k}</span> })),
    ]),
  ];
  return (
    <div data-testid="kanal-secici">
      <Select
        size="small"
        style={{ minWidth: 150 }}
        virtual={false}
        value={value ?? TUMU}
        onChange={(v: string) => onChange(v === TUMU ? null : v)}
        options={secenekler}
      />
    </div>
  );
}
